import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { ForecastMoneyCell, ForecastVarianceCell, ForecastPercentCell, ForecastConfidenceCell, ForecastStatusChip, ForecastDeltaClass, ForecastGridSx } from './ForecastGridRenderers';

type Props = { rows:any[]; loading?:boolean; selectedId?:any; onSelect?:(row:any)=>void };

class ForecastReconciliationGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'datasetcode', headerName: 'Dataset', width: 140 },
    { field: 'metriccode', headerName: 'Metric', width: 150 },
    { field: 'periodcode', headerName: 'Period', width: 120 },
    { field: 'sourceamount', headerName: 'Source', width: 140, renderCell: ForecastMoneyCell },
    { field: 'mappedamount', headerName: 'Mapped', width: 140, renderCell: ForecastMoneyCell },
    { field: 'differenceamount', headerName: 'Difference', width: 150, renderCell: ForecastVarianceCell, cellClassName: ForecastDeltaClass },
    { field: 'differencepercent', headerName: 'Difference %', width: 140, renderCell: ForecastPercentCell, cellClassName: ForecastDeltaClass },
    { field: 'reconciliationstatus', headerName: 'Status', width: 140, renderCell: ForecastStatusChip },
    { field: 'notes', headerName: 'Notes', width: 260, flex: 1, minWidth: 260 },
  ];

  getRowId = (row:any) => row.rid || row.recid || row.id || `${row.batchcode}-${row.datasetcode}-${row.metriccode}-${row.periodcode}-${row.reconciliationstatus}`;

  render() {
    return (
      <FDataGrid
        title="Reconciliation Detail"
        subtitle="Reconciliation differences between source workbook, mapped facts and model output."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={420}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#ffebee' }}
        getRowId={this.getRowId}
        onRowClick={(p:any) => this.props.onSelect?.(p.row)}
        pageSizeOptions={[10,25,50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        sx={ForecastGridSx}
      />
    );
  }
}

export default ForecastReconciliationGrid;
